import { checkoutTypes } from '../enums/checkout-types';
import { URL_IMPLEMENTATIONS, getUrlImplementation } from './getUrlImplementation';

export default function getCheckoutPath(sellerSlug, checkoutSlug, type = checkoutTypes.CHECKOUT) {
  const urlImplementation = getUrlImplementation();

  if (type === checkoutTypes.EMBED) {
    switch (urlImplementation) {
      case URL_IMPLEMENTATIONS.PATH:
        return `/embed/${sellerSlug}/${checkoutSlug}`;
      case URL_IMPLEMENTATIONS.DOMAIN:
      default:
        return `/embed/${checkoutSlug}`;
    }
  } else if (type === checkoutTypes.POPUP) {
    switch (urlImplementation) {
      case URL_IMPLEMENTATIONS.PATH:
        return `/overlay/${sellerSlug}/${checkoutSlug}`;
      case URL_IMPLEMENTATIONS.DOMAIN:
      default:
        return `/overlay/${checkoutSlug}`;
    }
  } else {
    switch (urlImplementation) {
      case URL_IMPLEMENTATIONS.PATH:
        return `/c/${sellerSlug}/${checkoutSlug}`;
      case URL_IMPLEMENTATIONS.DOMAIN:
      default:
        return `/${checkoutSlug}`;
    }
  }
}
